import { Route } from 'react-router';
import type { AppRoute } from '../index';

export function renderRoutes(routes: AppRoute[]) {
  return routes.map(({ path, element, children }) => (
    <Route key={path} path={path} element={element}>
      {children && renderRoutes(children)}
    </Route>
  ));
}
